import Chip from 'components/chip/chip';

// A row of shortcuts on the admin's chips (a day, a time, a length): the one
// chosen stands out, a click picks one. `options`: [[value, label]].
const ChoiceChips = ({ options, value, onPick }) => (
  <div className="flex flex-wrap gap-1.5">
    {options.map(([option, label]) => (
      <Chip key={option} type={value === option ? 'SELECTON' : 'SELECTOFF'} onClick={() => onPick(option)}>
        {label}
      </Chip>
    ))}
  </div>
);

export default ChoiceChips;
